import React, { useState } from 'react';
import { useProfile } from '../features/profile/hooks/useProfile';
import { ProfileHeader } from '../features/profile/components/ProfileHeader';
import { ActivityGraph } from '../features/profile/components/ActivityGraph';
import { ProfilePosts } from '../features/profile/components/ProfilePosts';
import { EditProfileDialog } from '../features/profile/components/EditProfileDialog';

const ProfilePage: React.FC = () => {
  const {
    user,
    posts,
    setPosts,
    loading: profileLoading,
    loadingPosts,
    refreshData,
    userLevel,
    levels
  } = useProfile();

  const [showEditDialog, setShowEditDialog] = useState(false);

  if (profileLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[var(--background-secondary)]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--background-secondary)] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto space-y-6">

        <ProfileHeader
          user={user}
          userLevel={userLevel}
          levels={levels}
          onEditProfile={() => setShowEditDialog(true)}
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column: Activity & Stats (or generic sidebar info later) */}
          <div className="lg:col-span-1 space-y-6">
            <ActivityGraph user={user} />
            {/* Add Memberships or other widgets here if needed */}
          </div>

          {/* Right Column: Posts/Feed */}
          <div className="lg:col-span-2">
            <ProfilePosts
              posts={posts}
              loading={loadingPosts}
              setPosts={setPosts}
              user={user}
            />
          </div>
        </div>
      </div>

      <EditProfileDialog
        open={showEditDialog}
        onOpenChange={setShowEditDialog}
        user={user}
        onSuccess={refreshData}
      />
    </div>
  );
};

export default ProfilePage;
